import { Flex, type FlexProps, Text } from '@/components';
import type { FC, ReactNode } from 'react';
import { SectionItem } from './SectionItem';

type Props = {
  title?: ReactNode;
  wrapperStyle?: FlexProps['style'];
  items: Array<{
    subtitle?: ReactNode;
    item: ReactNode;
    subtitleWrapperStyle?: FlexProps['style'];
    subtitleContentStyle?: FlexProps['style'];
    wrapperStyle?: FlexProps['style'];
  }>;
};

/**
 * @deprecated
 * ReportSectionを使うようにする
 */
export const Section: FC<Props> = ({ title, items, wrapperStyle }) => {
  return (
    <div
      style={{
        breakAfter: 'page',
      }}
    >
      <Flex
        vertical
        style={{
          gap: 2,
          ...wrapperStyle,
        }}
      >
        {(title && typeof title === 'string') || typeof title === 'number' ? (
          <Text text={title} />
        ) : (
          title
        )}
        {items.map((item, idx) => {
          return (
            <SectionItem
              // biome-ignore lint/suspicious/noArrayIndexKey: biomeをCIに仕込むために暫定的にignore。keyにユニークな値を指定するか適切な理由に書き換えること
              key={idx}
              wrapperStyle={{
                breakInside: idx === 0 ? undefined : 'avoid',
                ...item.wrapperStyle,
              }}
              title={item.subtitle}
              titleContentStyle={item.subtitleContentStyle}
              titleWrapperStyle={item.subtitleWrapperStyle}
            >
              {item.item}
            </SectionItem>
          );
        })}
      </Flex>
    </div>
  );
};
